import { Box, Divider } from '@mui/material';

import { Button, AddIcon } from '@occc-app/design-system';
import { useCanEditFormFieldsContext } from '@occc-app/App/CanEditFormFieldsContext';

export interface IAddAnotherItemProps {
  title: string;
  onClick: () => void;
}

export const AddAnotherItem = ({ title, onClick }: IAddAnotherItemProps) => {
  const { isEditable } = useCanEditFormFieldsContext();
  return (
    isEditable && (
      <>
        <Divider sx={{ mt: 2.5, mb: 2 }} />
        <Box display='flex' justifyContent='center'>
          <Button startIcon={<AddIcon />} variant='contained' color='primary' onClick={onClick}>
            {title}
          </Button>
        </Box>
      </>
    )
  );
};
